import { GridColumnExtraSettings, GridColumnSettings, GridTemplateCondition } from '@/shared/types/grid';
import {
  dateFormat,
  dayLongMonthFormat,
  dayMonthFormat,
  dayMonthYearFormat,
  dayMonthYearTimeFormat,
  timeFormat,
} from '@/shared/utils/format';
import { gridTemplateCondition } from '@/shared/utils/grid';

export const dateColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  header: string;
  headerTemplate?: string;
  displayField?: keyof T & string;
  emptyText?: string;
  emptyClass?: string;
  format?: 'date' | 'dayMonth' | 'dayLongMonth' | 'dayMonthYear' | 'dayMonthYearTime' | 'time';
  due?: boolean;
  dueIf?: GridTemplateCondition<T>;
  allowFiltering?: boolean;
  allowSorting?: boolean;
  width?: number;
  visible?: boolean;
  showInColumnChooser?: boolean;
  extra?: GridColumnExtraSettings<T>;
  chooserName?: string;
}): GridColumnSettings<T> => {
  const {
    uid,
    field,
    header,
    headerTemplate,
    displayField,
    emptyText = 'Not set',
    emptyClass = 'text-more-muted',
    due,
    dueIf,
    allowFiltering,
    allowSorting,
    width,
    visible,
    showInColumnChooser,
    extra,
    chooserName,
  } = options ?? {};

  let format = dayMonthYearFormat;
  let formatter = 'formatDayMonthYear';

  if (options?.format === 'date') {
    format = dateFormat;
    formatter = 'formatDate';
  } else if (options?.format === 'dayMonth') {
    format = dayMonthFormat;
    formatter = 'formatDayMonth';
  } else if (options?.format === 'dayMonthYear') {
    format = dayMonthYearFormat;
    formatter = 'formatDayMonthYear';
  } else if (options?.format === 'dayLongMonth') {
    format = dayLongMonthFormat;
    formatter = 'formatDayLongMonth';
  } else if (options?.format === 'time') {
    format = timeFormat;
    formatter = 'formatTime';
  } else if (options?.format === 'dayMonthYearTime') {
    format = dayMonthYearTimeFormat;
    formatter = 'formatDayMonthYearTime';
  }

  const dueCondition = dueIf ? gridTemplateCondition(dueIf) : undefined;

  let valueTemplate = `\${window.formatters.${formatter}(${field})}`;

  if (displayField) {
    valueTemplate = `\${${displayField}}`;
  }

  let template = emptyText
    ? `\${if(${field})}${valueTemplate}\${else}<span class="${emptyClass ?? ''}">${emptyText}</span>\${/if}`
    : valueTemplate;

  if (due || dueIf) {
    template = `\${if(${field})}${
      dueIf
        ? `<span class="\${if(${dueCondition})}\${window.formatters.dueDateClass(${field})}\${else}text-more-muted text-decoration-line-through\${/if}">${template}</span>`
        : `<span class="\${window.formatters.dueDateClass(${field})}">${template}</span>`
    }\${else}${template}\${/if}`;
  }

  return {
    uid: uid ?? field,
    field,
    headerText: header,
    headerTemplate,
    type: 'date',
    format,
    template,
    allowFiltering: allowFiltering ?? true,
    allowSorting: allowSorting ?? true,
    width: width ?? 150,
    visible: visible ?? true,
    showInColumnChooser: showInColumnChooser ?? true,
    chooserName,
    extra,
  };
};
